// Keep the responsive menu markup in step with the menu stylesheet.
export function isNarrowMenuViewport() {
  if (typeof window === 'undefined') return false;
  return typeof window.matchMedia === 'function'
    ? window.matchMedia('(max-width: 1024px)').matches
    : window.innerWidth <= 1024;
}



// WEBPACK FOOTER //
// ./src/utils/viewport.js